import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a-modal', {
    attrs: {
      "title": "".concat(_vm.detailData.department || '', "\u5B66\u90E8").concat(_vm.detailData.salaryMonth ? _vm.detailData.salaryMonth.split('-')[0] : '', "\u5E74").concat(_vm.detailData.salaryMonth ? _vm.detailData.salaryMonth.split('-')[1] : '', "\u6708\u5DE5\u8D44\u6761\u5BFC\u5165\u8BE6\u60C5"),
      "visible": _vm.visible,
      "width": 1200,
      "footer": null,
      "destroyOnClose": true
    },
    on: {
      "cancel": _vm.handleCancel
    }
  }, [_vm.detailData ? _c('div', [_c('a-card', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": "导入信息",
      "bordered": false
    }
  }, [_c('a-descriptions', {
    attrs: {
      "column": 2
    }
  }, [_c('a-descriptions-item', {
    attrs: {
      "label": "工资标题"
    }
  }, [_vm._v(_vm._s(_vm.detailData.salaryTitle))]), _c('a-descriptions-item', {
    attrs: {
      "label": "导入人"
    }
  }, [_vm._v(_vm._s(_vm.detailData.importUserName))]), _c('a-descriptions-item', {
    attrs: {
      "label": "导入时间"
    }
  }, [_vm._v(_vm._s(_vm.detailData.importTime))]), _c('a-descriptions-item', {
    attrs: {
      "label": "导入状态"
    }
  }, [_c('a-tag', {
    attrs: {
      "color": _vm.getImportStatusColor(_vm.detailData.importStatus)
    }
  }, [_vm._v(" " + _vm._s(_vm.getImportStatusText(_vm.detailData.importStatus)) + " ")])], 1), _c('a-descriptions-item', {
    attrs: {
      "label": "总记录数"
    }
  }, [_vm._v(_vm._s(_vm.detailData.recordCount))]), _c('a-descriptions-item', {
    attrs: {
      "label": "总表文件名"
    }
  }, [_vm._v(_vm._s(_vm.detailData.mainFileName))]), _c('a-descriptions-item', {
    attrs: {
      "label": "总表保存路径"
    }
  }, [_vm.detailData.mainFilePath ? _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function click($event) {
        return _vm.downloadFile(_vm.detailData.mainFilePath, _vm.detailData.mainFileName);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.detailData.mainFilePath) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.detailData.mainFilePath))])]), _c('a-descriptions-item', {
    attrs: {
      "label": "明细表文件名"
    }
  }, [_vm._v(_vm._s(_vm.detailData.detailFileName))]), _c('a-descriptions-item', {
    attrs: {
      "label": "明细表保存路径"
    }
  }, [_vm.detailData.detailFilePath ? _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function click($event) {
        return _vm.downloadFile(_vm.detailData.detailFilePath, _vm.detailData.detailFileName);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.detailData.detailFilePath) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.detailData.detailFilePath))])]), _c('a-descriptions-item', {
    attrs: {
      "label": "错误校验保存路径"
    }
  }, [_vm.detailData.errorFilePath && _vm.detailData.errorFilePath !== '无' ? _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function click($event) {
        return _vm.downloadFile(_vm.detailData.errorFilePath, '错误校验文件');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.detailData.errorFilePath) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.detailData.errorFilePath || '无'))])]), _c('a-descriptions-item', {
    attrs: {
      "label": "发送状态"
    }
  }, [_c('a-tag', {
    attrs: {
      "color": _vm.getSendStatusColor(_vm.detailData.sendStatus)
    }
  }, [_vm._v(" " + _vm._s(_vm.getSendStatusText(_vm.detailData.sendStatus)) + " ")])], 1), _c('a-descriptions-item', {
    attrs: {
      "label": "发送时间"
    }
  }, [_vm._v(_vm._s(_vm.sendTimeDisplay))])], 1)], 1), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "disabled": _vm.detailData.importStatus !== 1
    },
    on: {
      "click": _vm.sendSalarySlip
    }
  }, [_vm._v("发送工资条")])], 1), _c('a-tabs', {
    attrs: {
      "default-active-key": "1"
    }
  }, [_c('a-tab-pane', {
    key: "1",
    attrs: {
      "tab": "工资总表明细"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('a-input-search', {
    staticStyle: {
      "width": "300px",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请输入姓名或身份证号码进行搜索",
      "allowClear": "",
      "enterButton": ""
    },
    on: {
      "search": _vm.handleSearchMain,
      "change": _vm.handleMainSearchChange
    },
    model: {
      value: _vm.mainSearchValue,
      callback: function callback($$v) {
        _vm.mainSearchValue = $$v;
      },
      expression: "mainSearchValue"
    }
  }), _c('a-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    on: {
      "click": _vm.refreshMainData
    }
  }, [_vm._v("刷新")]), _c('a-button', {
    on: {
      "click": _vm.exportMainData
    }
  }, [_vm._v("导出数据")])], 1), _c('a-table', {
    attrs: {
      "columns": _vm.mainColumns,
      "data-source": _vm.mainData,
      "pagination": {
        current: _vm.mainPagination.current,
        pageSize: _vm.mainPagination.pageSize,
        total: _vm.mainPagination.total,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      "loading": _vm.mainLoading,
      "row-key": "id",
      "scroll": {
        x: 'max-content'
      }
    },
    on: {
      "change": _vm.handleMainTableChange
    }
  })], 1), _c('a-tab-pane', {
    key: "2",
    attrs: {
      "tab": "奖励性绩效明细"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('a-input-search', {
    staticStyle: {
      "width": "300px",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请输入姓名或身份证号码进行搜索",
      "allowClear": "",
      "enterButton": ""
    },
    on: {
      "search": _vm.handleSearchDetail,
      "change": _vm.handleDetailSearchChange
    },
    model: {
      value: _vm.detailSearchValue,
      callback: function callback($$v) {
        _vm.detailSearchValue = $$v;
      },
      expression: "detailSearchValue"
    }
  }), _c('a-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    on: {
      "click": _vm.refreshDetailData
    }
  }, [_vm._v("刷新")]), _c('a-button', {
    on: {
      "click": _vm.exportDetailData
    }
  }, [_vm._v("导出数据")])], 1), _c('a-table', {
    attrs: {
      "columns": _vm.detailColumns,
      "data-source": _vm.detailDataList,
      "pagination": {
        current: _vm.detailPagination.current,
        pageSize: _vm.detailPagination.pageSize,
        total: _vm.detailPagination.total,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      "loading": _vm.detailLoading,
      "row-key": "id",
      "scroll": {
        x: 'max-content'
      }
    },
    on: {
      "change": _vm.handleDetailTableChange
    }
  })], 1)], 1)], 1) : _vm._e(), _c('salary-send-modal', {
    attrs: {
      "visible": _vm.sendModalVisible,
      "record": _vm.currentSendRecord
    },
    on: {
      "confirm-send": _vm.handleConfirmSend,
      "cancel": _vm.handleSendModalCancel
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };